import type { ColDef } from '@/grid/types';

export const ROW_NUMBER_COLUMN = {
  colId: 'rowNumber',
  headerName: '#',
  valueGetter: (params) =>
    typeof params.node?.rowIndex === 'number' ? params.node.rowIndex + 1 : '',
  width: 55,
  minWidth: 55,
  maxWidth: 55,
  pinned: 'left',
  lockPosition: true,
  suppressMovable: true,
  suppressNavigable: true,
  suppressHeaderMenuButton: true,
  editable: false,
  sortable: false,
  filter: false,
  resizable: false,
} satisfies ColDef<object>;
